import { useQuery } from '@tanstack/react-query';
import { getAvatar } from '../core/getAvatar.js';

/**
 * Gets an ensName and resolves the Avatar
 */
const useAvatar = ({
  ensName
}, queryOptions) => {
  const _ref = queryOptions ?? {},
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    cacheTime = _ref.cacheTime;
  const ensActionKey = `ens-avatar-${ensName}`;
  return useQuery({
    queryKey: ['useAvatar', ensActionKey],
    queryFn: async () => {
      return await getAvatar(ensName);
    },
    gcTime: cacheTime,
    enabled,
    refetchOnWindowFocus: false
  });
};
export { useAvatar };
//# sourceMappingURL=useAvatar.js.map
